module.exports = __webpack_public_path__ + "static/img/5793_phase_function_Paper_Points.25883e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5793_phase_function_Paper_Points.png
// module id = BwW5
// module chunks = 0